/** Get Dashboard Chart data */
export const API_SUCCESS = "API_SUCCESS";
export const API_FAIL = "API_FAIL";
export const GET_CHARTS_DATA = "GET_CHARTS_DATA";

export const FETCH_EMPLOYEE_DASHBOARD_REQUEST = "FETCH_EMPLOYEE_DASHBOARD_REQUEST";
export const FETCH_EMPLOYEE_DASHBOARD_SUCCESS = "FETCH_EMPLOYEE_DASHBOARD_SUCCESS";
export const FETCH_EMPLOYEE_DASHBOARD_FAILURE = "FETCH_EMPLOYEE_DASHBOARD_FAILURE";

export const SEND_BIRTHDAY_WISHES_REQUEST = "SEND_BIRTHDAY_WISHES_REQUEST";
export const SEND_BIRTHDAY_WISHES_SUCCESS = "SEND_BIRTHDAY_WISHES_SUCCESS";
export const SEND_BIRTHDAY_WISHES_FAILURE = "SEND_BIRTHDAY_WISHES_FAILURE";

export const FETCH_HR_DASHBOARD_REQUEST = "FETCH_HR_DASHBOARD_REQUEST";
export const FETCH_HR_DASHBOARD_SUCCESS = "FETCH_HR_DASHBOARD_SUCCESS";
export const FETCH_HR_DASHBOARD_FAILURE = "FETCH_HR_DASHBOARD_FAILURE";

export const FETCH_HOD_DASHBOARD_REQUEST = "FETCH_HOD_DASHBOARD_REQUEST";
export const FETCH_HOD_DASHBOARD_SUCCESS = "FETCH_HOD_DASHBOARD_SUCCESS";
export const FETCH_HOD_DASHBOARD_FAILURE = "FETCH_HOD_DASHBOARD_FAILURE";

export const FETCH_ORG_CHART_REQUEST = "FETCH_ORG_CHART_REQUEST";
export const FETCH_ORG_CHART_SUCCESS = "FETCH_ORG_CHART_SUCCESS";
export const FETCH_ORG_CHART_FAILURE = "FETCH_ORG_CHART_FAILURE";

export const FETCH_HOD_DASHBOARDPROJECTVIEW_REQUEST = "FETCH_HOD_DASHBOARDPROJECTVIEW_REQUEST";
export const FETCH_HOD_DASHBOARDPROJECTVIEW_SUCCESS = "FETCH_HOD_DASHBOARDPROJECTVIEW_SUCCESS";
export const FETCH_HOD_DASHBOARDPROJECTVIEW_FAILURE = "FETCH_HOD_DASHBOARDPROJECTVIEW_FAILURE";

export const FETCH_HR_DASHBOARDPROJECTVIEW_REQUEST = "FETCH_HR_DASHBOARDPROJECTVIEW_REQUEST";
export const FETCH_HR_DASHBOARDPROJECTVIEW_SUCCESS = "FETCH_HR_DASHBOARDPROJECTVIEW_SUCCESS";
export const FETCH_HR_DASHBOARDPROJECTVIEW_FAILURE = "FETCH_HR_DASHBOARDPROJECTVIEW_FAILURE";